import { PayPeriodDto, PayrollShiftListItemDto } from '@clh/api-client';

export function scheduledMinutesSortValue(
    shift: PayrollShiftListItemDto
): number {
    return (shift.endTime.getTime() - shift.startTime.getTime()) / 60_000;
}

export function nurseNameSortValue(shift: PayrollShiftListItemDto): string {
    const nurse = shift.nurseProfile;
    return nurse ? `${nurse.firstName} ${nurse.lastName}` : '';
}

export function findPayPeriod(
    shift: PayrollShiftListItemDto,
    payPeriodStart: Date,
    payPeriodEnd: Date
): PayPeriodDto | undefined {
    return shift.payPeriods?.find(
        (pp) =>
            pp.canonicalStart.getTime() === payPeriodStart.getTime() &&
            pp.canonicalEnd.getTime() === payPeriodEnd.getTime()
    );
}

// Mirrors the Hours Submitted cell: pay period minutes win over shift totals.
// Did-not-work and not-submitted shifts sort below any submitted time.
export function submittedMinutesSortValue(
    shift: PayrollShiftListItemDto,
    payPeriod: PayPeriodDto | undefined
): number {
    if (shift.didNotWork) {
        return -2;
    }
    if (!shift.minutesWorked && !shift.onCallShift?.minutesWorked) {
        return -1;
    }
    if (payPeriod?.minutesWorked || payPeriod?.onCallMinutesWorked) {
        return (
            (payPeriod.minutesWorked || 0) +
            (payPeriod.onCallMinutesWorked || 0)
        );
    }
    return (shift.minutesWorked || 0) + (shift.onCallShift?.minutesWorked || 0);
}
